import { Component } from '@angular/core';

@Component({
  selector: 'ct-page-not-authorized',
  templateUrl: './page-not-authorized.component.html',
  styleUrls: ['./page-not-authorized.component.css']
})
export class PageNotAuthorizedComponent {
}

